<template>

    <div id="pcontent">

        <router-link to="/home">

            <div class="back">返回</div>

        </router-link>


		<div class="p_content">
			<div class="p_info">
				<img :src="api+list.img_url_big"/>
				<h2>{{list.title}}</h2>
				<p class="price">{{list.price}}/份</p>
			</div>
			<div class="p_detial">
				<h3>
					商品详情<!--hidden="hidden"-->
				</h3>
				<div class="p_content" v-html='list.content'>

				</div>
        <!--<div class="cool" id="cool" v-if="play">
          <input type="radio" id="one" value="冰" v-model="picked">
          <label for="one">冰</label>
          <br>
          <input type="radio" id="two" value="不冰" v-model="picked">
          <label for="two">不冰</label>
          <br>
          <span  id="picked">{{ picked }}</span>
        </div>-->
        <div v-show="play">
          <div class="radio-box" v-for="(item,index) in radios" :key="item.id">
            <span class="radio" :class="{'on':item.isChecked}"></span>
            <input v-model="payType" :value="item.value" class="input-radio" :checked='item.isChecked'  @click="check(index)" type="radio">{{item.label}}

          </div>
           <span hidden="hidden" id="payType">{{payType}}</span>
        </div>


			</div>
		</div>




		<footer class="pfooter">

			<div class="cart">
				<strong>数量:</strong>
				<div class="cart_num">
		          <div class="input_left" @click="decNum()">-</div>
		          <div class="input_center">
		              <input type="text"  readonly="readonly" v-model='num' name="num" id="num" />
		          </div>
		          <div class="input_right"  @click="incNum()">+</div>
		        </div>

			</div>

			<button class="addcart" @click="addCart()">
                    加入购物车

            </button>
		</footer>


    </div>
</template>


<script>


    //引入config

    import  Config from '../model/config.js';

    import storage from '../model/storage.js';
    export default{
        el:'pcontent',
        data () {
            return {
                  api:Config.api,
                  list:[],
                  num:1,
                  picked: '',
                  play: false,

                  payType: '不冰',
                          radios:[
                            {
                              label: '冰',
                              value:'冰',
                              isChecked: false,
                            },
                            {
                              label: '不冰',
                              value:'不冰',
                              isChecked: true,
                            },
                          ]
                 //参考：https://blog.csdn.net/weixin_36934930/article/details/80844679
            }
        },
        methods:{

            check(index) {
                  // 先取消所有选中项
                  this.radios.forEach((item) => {
                    item.isChecked = false;
                  });
                  //再设置当前点击项选中
                  this.payType = this.radios[index].value;
                  // 设置值，以供传递
                  this.radios[index].isChecked = true;
                  console.log(this.payType);
                },
                loadData(){
                    // 设置一进来是  在线支付  还是  线下支付
                    _this.payType = data.FPayType
                    if(data.FPayType === "冰"){
                      _this.$set(_this.radios[0],'isChecked',true)
                      _this.$set(_this.radios[1],'isChecked',false)
                    }else{
                      _this.$set(_this.radios[0],'isChecked',false)
                      _this.$set(_this.radios[1],'isChecked',true)
                    }
                },

            requestData(id){

                var api=this.api+'api/productcontent?id='+id
                this.$http.get(api).then((response)=>{

                    console.log(response);

                    this.list=response.body.result[0];

                    if (this.list.cool.length>0) {
                      this.play=true}//szy add

                },(err)=>{

                    console.log(err);
                })
            },
            decNum(){
                if(this.num>1){
                    --this.num;
                }
            },
            incNum(){
                ++this.num;
            } ,
            addCart(){

                //获取冰，不冰
                if (this.play==true) {

                  //表示选择了冰火不冰，再在商品名称前后加上[]
                  //this.picked = this.querySelector('#picked').innerHTML.trim();
                  this.picked = document.getElementById('payType').innerHTML;

                  if (this.picked.length<1) {
                    alert('请选择冰或不冰');
                    return;//中止函数执行
                  }

                } else {this.picked=''}


                //if (this.picked.length>2 && this.play=true) {//因为有[],所以要大于2

                //获取数据加入购物车

                var uid=String(storage.get('roomid'));
                var p_mark=String(storage.get(uid));//mob

                var api=this.api+'api/addcart';

                this.$http.post(api,{
                    uid:String(uid),
                    title:this.list.title,
                    price:this.list.price,
                    num:this.num,
                    product_id:this.list._id,
                    img_url:this.list.img_url,
                    p_mark:String(p_mark),//手机号
                    cool:this.picked//冰火不冰
                }).then((response)=>{
                    console.log(response);

                    if(response.body.success){

                        //加入购物车的时候给服务器发消息
                        this.$socket.emit('addcart','addcart');

                        this.$router.push({ path: 'home' })
                    }

                },(err)=>{

                    console.log(err);

					          alert('加入失败，手机号不正确，请退出再扫码('+uid+'/'+p_mark+')');//szy add
                    storage.clear();//第一次填错了，没有地方可以修改号码
                    //this.$router.push({
                    //  path: 'start'
                    //});
                })
             // } else {
             //   alert('请选择:冰或不冰');//szy add，所有的商品都要选择吗？喝到嘴里的都要选择
             // }
            }
        },
        mounted(){

            //动态路由

            // { path: '/pcontent/:id', component: Pcontent },
            //console.log(this.$route.params);


            //get传值
            // console.log(this.$route.query);


            var id=this.$route.query.id;

            this.requestData(id);

        }
    }
</script>

<style lang="scss">

.back{


    height: 3.8rem;
    line-height: 3.8rem;
    width: 3.8rem;

    border-radius: 50%;


    background: #000;


    position: fixed;


    top: .5rem;

    left: .5rem;

    color: #fff;


    &:before{


         content: "";

         display: block;

         width: .8rem;
         height: .8rem;

         border-left: .2rem solid #fff;
         border-bottom: .2rem solid #fff;

         float: left;

         position: relative;

         top:1.3rem;

         left:.6rem;

         transform: rotate(45deg);

         margin-right: .4rem;

    }
}

.p_content{

    .p_info{
        background: #fff;
        img{
            width: 100%;

            height: 18rem
        }

        h2{
            padding: .2rem .5rem;
        }

        .price{

              padding: .2rem .5rem;

              color: red;
        }
    }

    .p_detial{


         background: #fff;

         margin-top: 1rem;

         h3{
             padding: .5rem;
         }

         .cool {
           padding: 1rem;

           input {

             height: 4rem;
             line-height: 4rem;

             font-size: 4.5rem; //szy add

             width: 100%;
             border: 1px solid #eee;
           }

         }

          .radio-box{
            display: inline-block;
            position: relative;
            height: 4rem;
            line-height: 4rem;
            margin-right: 0.8rem;

            font-size: 4.5rem; //szy add
          }
          .input-radio {
            display: inline-block;
            position: absolute;
            opacity: 0;
            width: 4rem;
            height: 4rem;
            cursor: pointer;
            left: 0px;
            outline: none;
            -webkit-appearance: none;
          }
          .radio {
            display: inline-block;
            width: 4rem;
            height: 4rem;
            vertical-align: middle;
            cursor: pointer;
            background-image: url(../assets/images/OS_Box_Empty.png);
            background-repeat: no-repeat;
            //background-position: 0 0;
            background-size: 100% 100%;
            //雪碧图
          }
          .on {
            background-image: url(../assets/images/OS_Box_On.png);
            background-size: 100% 100%;
            //background-position: -25px 0;  //雪碧图
          }

         .p_content{
             padding: 1rem;


             img{
                 max-width: 100%;

                 display: block;

                 margin: 0 auto;
             }

             *{

                  line-height: 1.5;

                  color: #666;
             }
         }
    }


}



/*底部*/

.pfooter{


  position: fixed;

  bottom: 0px;
  height: 4.4rem;
  line-height: 4.4rem;

  background: #fff;

  left: 0px;

  width: 100%;

  border-top: 1px solid #eee;

  .cart{

      float: left;


      display:flex;

      strong{

          flex: 1;

          font-size: 1.6rem;

          padding: 0rem .5rem;
      }

      .cart_num{

          width: 10rem;

          display: flex;
          margin-top: .8rem;


          .input_left,.input_right{
              flex: 1;

              width: 2.8rem;
              height: 2.8rem;

              line-height: 2.8rem;

              text-align: center;

              color: red;

              border: 1px solid #eee;

              font-size: 2.4rem;
          }

          .input_center{

              flex: 1;

              input{

                   width: 2rem;
                   text-align: center;
                    width: 100%;
                    height: 2.8rem;
                    border: none;

                     border-top: 1px solid #eee;

                     border-bottom: 1px solid #eee;

                     float: left;
              }
          }
      }

  }

  .addcart{

        float: right;

        background: red;
        color: #fff;
        height: 3rem;
        border: none;
        padding: 0 .5rem;
        border-radius: .5rem;
        margin-top: .8rem;
        margin-right: .5rem;

        a{

             color:#fff;

        }
  }

}


</style>



// WEBPACK FOOTER //
// src/components/Pcontent.vue